
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/startup-benefits/[slug]",
      function () {
        return require("private-next-pages/startup-benefits/[slug].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/startup-benefits/[slug]"])
      });
    }
  